import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { styled } from '@mui/material/styles';

const Overlay = styled('div')({
    display: 'block',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: '#fff',
    zIndex: 3,
    transition: 'opacity 725ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    '@media print': {
        display: 'none',
    },
});

const AnalyticsWrapper = ({ children, className }) => {
    const [isPrintOverlay, setPrintOverlay] = useState(false);

    const handleBeforePrint = () =>
        ReactDOM.flushSync(() => {
            setPrintOverlay(true);
        });
    const handleAfterPrint = () => setPrintOverlay(false);

    useEffect(() => {
        window.addEventListener('beforeprint', handleBeforePrint);
        window.addEventListener('afterprint', handleAfterPrint);

        return () => {
            window.removeEventListener('beforeprint', handleBeforePrint);
            window.removeEventListener('afterprint', handleAfterPrint);
        };
    }, []);

    return (
        <>
            {isPrintOverlay && <Overlay />}
            <div className={className}>{children}</div>
        </>
    );
};

export default AnalyticsWrapper;
